/*
 * 微宠医（WCY）域接口：SKU 映射 / 处方发布 / 事件通知 / 医院信息
 *
 * @Author: Mustafa.Yin
 * @Date: 2026-10-31
 */
import { get, post, request } from '@/utils/request';

/**
 * 处方商品 SKU 映射：mainItem → 微宠医 productId/skuList
 * @param {string|number} codeList 商品 mainItem
 * @param {string|number} companyId 公司 id
 * @returns {Promise<Array>} 微宠医商品列表
 */
export function getPrescriptionGoods(codeList, companyId) {
  return get('smartreco/api/getPrescriptionGoods', { codeList, companyId }, { apiName: 'prescriptionGoods' });
}

/**
 * 发布处方（干粮/湿粮各调用一次）
 * @returns {Promise<any>} 发布结果
 */
export function sendPrescription(data) {
  return post('smartreco/api/sendPrescription', data, { apiName: 'sendPrescription' });
}

/**
 * 发布处方后通知微宠医（feature: SR 干粮 / DA 湿粮）
 */
export function notifyEvent(shopId, feature) {
  return get(`smartreco/api/event/${shopId}/${feature}`, null, { apiName: 'event' });
}

/**
 * 由 mdmCode 换取医院信息（shopId/shopName/address/phone/encPhone）
 */
export function getHospitalByMdMNo(mdmNo) {
  return post('smartreco/api/getHospitalByMdMNo', null, { params: { mdmNo }, apiName: 'getHospitalByMdMNo' });
}
